import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  NgZone,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { ScrollToTop } from '../../utils/functions';
import { getEncripted } from '../../utils/pw-encripted';
import { GlobalValidators } from '../../utils/validators';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialog } from '../dialogs/dialog';
import { ConfirmPasswordComponent } from '../../portal/confirm-password/confirm-password.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-set-pin',
  templateUrl: './set-pin.component.html',
  styleUrls: ['./set-pin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetPinComponent implements OnInit {
  @Input() currentUser;
  @Input() mfa;
  @Output() forgotPinStatus = new EventEmitter<any>();
  @Output() newPinEnterScreen = new EventEmitter<any>();
  contactNumber = new FormControl('', [GlobalValidators.required, GlobalValidators.pattern(/\d{10}/i)]);
  errorMsg: any;
  successMsg = '';
  otpScreen;
  pinScreen;
  currentUserLoading = false;
  primaryNumberMissMatch = false;
  card_view = false;
  savingPin = false;

  pinCode(pinCode: any) {
    throw new Error('Method not implemented.');
  }

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    public translate: TranslateService
  ) {
    this.route.queryParams.subscribe(async (data) => {
      if (data['payment']) {
        this.ngZone.run(() => {
          this.card_view = true;
          this.mfa = true;
        });
      }
    });
  }

  async ngOnInit() {
    if (!this.currentUser) {
      try {
        this.currentUserLoading = true;
        this.cdref.detectChanges();
        this.currentUser = await this.accountService.loadCurrentUserFromServer();
        if (this.currentUser?.isPinAvailable) {
          this.otpScreen = true;
          this.cdref.detectChanges();
        }
        this.currentUserLoading = false;
        this.cdref.detectChanges();
      } catch (e) {
        this.currentUserLoading = false;
        this.cdref.detectChanges();
      }
    } else {
      if (this.currentUser?.isPinAvailable) {
        this.otpScreen = true;
        this.cdref.detectChanges();
      }
    }
    this.contactNumber.valueChanges.subscribe((data) => {
      this.primaryNumberMissMatch = false;
      this.cdref.detectChanges();
    });
  }

  validateContactNumber = () => {
    this.primaryNumberMissMatch = false;
    this.cdref.detectChanges();
    // console.log(this.currentUser.formattedMobileNumber);
    if (this.otpScreen) {
      this.otpScreen = !this.otpScreen;
      this.contactNumber.reset();
      this.cdref.detectChanges();
    }
    if (this.contactNumber.invalid) {
      return;
    }
    if (
      (this.contactNumber.value
        ? this.contactNumber.value.charAt(0) === '0'
          ? this.contactNumber.value.substring(1)
          : this.contactNumber.value
        : '') ===
      (this.currentUser.formattedMobileNumber
        ? this.currentUser.formattedMobileNumber.charAt(0) === '0'
          ? this.currentUser.formattedMobileNumber.substring(1)
          : this.currentUser.formattedMobileNumber
        : '')
    ) {
      OpenDialog(ConfirmPasswordComponent, { passwordValidator: true })
        .then(async (data) => {
          this.otpScreen = true;
          this.cdref.detectChanges();
        })
        .catch(() => { });
    } else {
      this.primaryNumberMissMatch = true;
      this.cdref.detectChanges();
    }
  };

  savePin = async (update = false) => {
    this.otpScreen = false;
    this.savingPin = true;
    this.cdref.detectChanges();
    try {
      if (update) {
        await this.accountService.updatePIN({ pin: getEncripted.bind(this)(this.pinCode) });
      } else {
        await this.accountService.savePIN({ pin: getEncripted.bind(this)(this.pinCode) });
      }
      this.savingPin = false;
      this.cdref.detectChanges();
      this.successMsg = 'Your PIN Saved';
      this.cdref.detectChanges();

      setTimeout(async () => {
        // this.pinSaved.emit()
        this.route.queryParams.subscribe(async (data) => {
          if (data['payment']) {
            await this.router.navigate(['dashboard/easy-pay'], { queryParams: { uid: `${this.currentUser.id}` } });
          }
          // console.log(data)
        });
        this.forgotPinStatus.emit(false);
      }, 2000);
    } catch (e) {
      this.savingPin = false;
      this.errorMsg = e?.error?.message;
      this.cdref.detectChanges();
      // console.log(this.errorMsg);
    }
  };

  successfullySentOTP = (e) => {
    this.newPinEnterScreen.emit(true);
    // console.log(e);
    if (e === 'save') {
      this.savePin();
    } else {
      this.pinScreen = true;
      this.successMsg = '';
      this.cdref.detectChanges();
    }
  };

  returnPin = (e) => {
    // console.log(e);
    this.pinCode = e;
    if (this.currentUser?.isPinAvailable) {
      this.savePin(true);
    } else {
      this.otpScreen = true;
    }

    ScrollToTop();
  };
}
